export type { Environment } from '@environments/environment.types';

export enum EMetodosDePago {
  CASH = 'Cash',
  BANK_TRANSFER = 'BankTransfer',
  WALLET = 'Wallet',
  BANK_TRANSFER_BUSINESS = 'BankTransfer_Businesses'
}
